import _ from 'lodash'
import CasBox from './CasBox'

export default {
  name: 'KCasSection',
  provide() {
    return {
      onNodeClick: this.handleNodeClick,
      KCasSection: this,
    }
  },
  props: {
    checked: {
      type: Array,
    },
    data: {
      type: Array, // 数据源
      default() {
        return []
      },
    },
    tabBy: {
      type: Function,
      default: null,
    },
    groupBy: {
      type: Function,
      default: null,
    },
    limit: {
      type: Number,
    },
    mode: {
      type: String,
    },
    activeTab: {
      type: String,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  render() {
    const content = this.tryRenderTabs()
    return (
      <div class="km-cascade__section">
        {content}
      </div>
    )
  },
  methods: {
    tryRenderTabs() {
      if (_.isFunction(this.tabBy)) {
        return <k-tabs value={this.activeTab}>{
          _.map(this.tabBy(this.data), tabItem => {
            return <k-tab-pane
              name={tabItem.name}
              tab={tabItem.tab}
            >
              <CasBox
                data={tabItem.children}
                groupBy={this.groupBy}
              />
            </k-tab-pane>
          })
        }</k-tabs>
      } else {
        return <CasBox
          data={this.data}
          groupBy={this.groupBy}
        />
      }
    },
    handleNodeClick(option) {
      this.$nextTick(() => {
        this.$emit('nodeClick', option)
      })
    },
  },
}
